(function () {
  class FireballAnimation extends PIXI.Container {
    constructor() {
      super();

      this._whoosh = ["fireWhoosh1", "fireWhoosh2", "fireWhoosh3"];

      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
    }

    onOrientationChange() {
      this._targetPos = this.findChild(
        this._posData.children[0].children,
        "fireball_secondPosEnd"
      );

      this._lightningAnim.x = this._targetPos.x;
      this._lightningAnim.y = this._targetPos.y;

      this._shockwaveAnim.x = this._targetPos.x;
      this._shockwaveAnim.y = this._targetPos.y;

      if (this._fireballContainer) {
        this._fireballContainer.x = this._targetPos.x;
        this._fireballContainer.y = this._targetPos.y;
      }
    }

    findChild(parent, name) {
      const child = parent.find(function (child) {
        return child.Props.ID === name;
      });
      return child;
    }

    onGameConfigEvent() {
      this._posData = this.findChild(this.children[0].children, "posData");

      this._targetPos = this.findChild(
        this._posData.children[0].children,
        "fireball_secondPosEnd"
      );

      this._fireballContainer = this.findChild(
        this.children[0].children,
        "fireballContainer"
      );

      if (this._fireballContainer) {
        this._fireballContainer.x = this._targetPos.x;
        this._fireballContainer.y = this._targetPos.y;
      }

      this._lightningAnim = this.findChild(
        this.children[0].children,
        "lightning"
      );
      this._lightningAnim.gotoAndStop(0);
      this._lightningAnim.visible = false;
      this._lightningAnim.x = this._targetPos.x;
      this._lightningAnim.y = this._targetPos.y;

      this._shockwaveAnim = this.findChild(
        this.children[0].children,
        "shockwave"
      );
      this._shockwaveAnim.gotoAndStop(0);
      this._shockwaveAnim.visible = false;
      this._shockwaveAnim.x = this._targetPos.x;
      this._shockwaveAnim.y = this._targetPos.y;
      this._shockwaveAnim.blendMode = PIXI.BLEND_MODES.ADD;

      Reflex.registerEventHandler(
        "orientationChange",
        this.onOrientationChange.bind(this)
      );
    }

    animate(callback) {
      this._callback = callback;

      let ran = this.getRandomInt(30);
      let self = this;

      timerManager.addTimeout(200, function () {
        self._lightningAnim.gotoAndPlay(ran);
        self._lightningAnim.visible = true;

        self._shockwaveAnim.gotoAndPlay(0);
        self._shockwaveAnim.visible = true;
      });

      timerManager.addTimer(
        300,
        function () {},
        function () {
          self._callback();
        }
      );

      timerManager.addTimer(
        700,
        function () {},
        function () {
          self._lightningAnim.gotoAndStop(0);
          self._lightningAnim.visible = false;

          self._shockwaveAnim.visible = false;
        }
      );
    }

    stopLightning() {
      this._lightningAnim.gotoAndStop(0);
      this._lightningAnim.visible = false;
    }

    getRandomInt(max) {
      return Math.floor(Math.random() * max);
    }
  }

  var fireballAnimationCreator = function (json) {
    return new FireballAnimation();
  };

  var fireballAnimationInitialiser = function (json, fireballAnimation) {};

  var fireballAnimationFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "fireballAnimation",
    fireballAnimationCreator,
    fireballAnimationInitialiser,
    fireballAnimationFilesRequired
  );
})();
